import React, {useEffect, useState} from 'react'
import {ITimesheet, IUser} from "../../../models";
import {useSelector} from "react-redux";
import {MonthNumber} from "../../../constants/MonthNumber";

interface ISummaryEmployeesExportTableProps {
    statisticForTable: any
    isOpen: boolean
}

export const SummaryEmployeesExportTableCosts: React.FC<ISummaryEmployeesExportTableProps> = ({statisticForTable, isOpen}) => {

    const [statProjectForExport, setStatProjectForExport]: any = useState([])
    const [statUserForExport, setStatUserForExport]: any = useState([])
    const [allSumForTable, setAllSumForTable] = useState(0)

    const chosenTimesheet: ITimesheet = useSelector((state: any) => state.toolkit.chosenTimesheet)
    
    useEffect(() => {
        setAllSumForTable(0)

        statUserForExport.reduce((sum: any, curr: any) => {
            setAllSumForTable(prev => prev + curr.sum)
        }, 0)
    }, [statUserForExport])

    useEffect(() => {
        if(!statisticForTable.length) return
        
        const log = statisticForTable?.map((user: any) => {
            return user?.data?.map((proj: any) => proj.project)
        })

        setStatUserForExport(statisticForTable)

        let newArray: any = []
        let finalArray: any = []

        for (let i = 0; i < log.length; i++) {
            if(!log[i]) return
            newArray?.push(...log[i])
        }

        for (let i = 0; i < newArray.length; i++) {
            if (!finalArray.some((item: any) => item.id === newArray[i].id)) {
                finalArray.push(newArray[i])
            }
        }

        setStatProjectForExport(finalArray)
    }, [statisticForTable])

    const findProject: any = (data: any, proj: any) => {
        return data.filter((item: any) => item.project.id === proj.id)[0]?.expense?.sum ? data.filter((item: any) => item.project.id === proj.id)[0]?.expense?.sum.toFixed(2) : 0
    }
    const sumTotalForProj: any = (proj: any) => {

        let sum = 0;
        let amount = 0;

        statisticForTable.forEach((user: any) => {

            sum = user.data.filter((item: any) => item.project.id === proj.id).reduce((_: any, current: any) => {
                amount = amount + current.expense?.sum
            }, amount)

        })

        return sum?.toFixed(2);
    }

    return (
        <>

            {isOpen && <table
                border={2}
                style={{
                    borderCollapse: 'collapse',
                    backgroundColor: '#fff',
                    fontFamily: 'Calibri',
                    width: '100%',
                }}
                id="my-table-new"
                className="table-to-download-excel"
            >

                <tbody>
                    <tr>
                        <td style={{height: "21px"}}>
    
                        </td>
                    </tr>
    
                    <tr>
                        <td style={{textAlign: "center", fontSize: "24px"}} colSpan={statProjectForExport.length + 2}>
                            <b>Project Controling</b>
                        </td>
                    </tr>
    
                    <tr>
                        <td style={{height: "21px"}}>
    
                        </td>
                    </tr>
    
                    <tr>
                        <td style={{fontSize: "12px"}} colSpan={statProjectForExport.length + 2}>
                            <b style={{textAlign: "center"}}>{chosenTimesheet?.date && MonthNumber()[+`${chosenTimesheet?.date[3]}${chosenTimesheet?.date[4]}`].translate},
                                20{`${chosenTimesheet?.date && chosenTimesheet?.date[6]}${chosenTimesheet?.date && chosenTimesheet?.date[7]}`}</b>
                        </td>
                    </tr>
    
                    <tr>
                        <td style={{height: "21px"}}>
    
                        </td>
                    </tr>
    
                    <tr>
                        <td style={{color: "#fff", background: "#FF0A00", textAlign: "center", border: "1px solid #000"}}
                            colSpan={2}>
                            iC Ukraine Internal
                        </td>
    
                        {
                            statProjectForExport.map((item: any) =>
                                <td style={{
                                    verticalAlign: "top",
                                    textAlign: "center",
                                    color: "#fff",
                                    background: "#FF0A00",
                                    border: "1px solid #000"
                                }}>
                                    {item?.name}
                                </td>
                            )
                        }
    
                        <td style={{color: "#fff", background: "#FF0A00", border: "1px solid #000"}}>Costs</td>
                    </tr>
    
                    <tr>
                        <td style={{width: "25px", textAlign: "center", color: "#fff", background: "#FF0A00", border: "1px solid #000"}}>
                            <b>No</b>
                        </td>
                        <td style={{width: "138px", textAlign: "center", color: "#fff", background: "#FF0A00", border: "1px solid #000"}}>
                            <b>Description</b>
                        </td>
    
                        {
                            statProjectForExport.map((item: any) =>
                                <td style={{
                                    width: "91px",
                                    textAlign: "center",
                                    verticalAlign: "top",
                                    color: "#fff",
                                    background: "#FF0A00", border: "1px solid #000"
                                }}>
                                    <b>{item?.description}</b>
                                </td>
                            )
                        }
    
                        <td style={{
                            width: "48px",
                            verticalAlign: "top",
                            textAlign: "center",
                            color: "#fff",
                            background: "#FF0A00", border: "1px solid #000"
                        }}>
                            <b>Total</b>
                        </td>
                    </tr>
    
                    {
                        statUserForExport.map((item: any, index: number) =>
                            <tr key={item.id}>
                                <td style={{textAlign: "center", background: "#f2f2f2"}}>
                                    {index + 1}
                                </td>
                                <td style={{background: "#f2f2f2"}}>
                                    {item?.description}
                                </td>
    
                                {
                                    statProjectForExport.map((proj: any) =>
                                        <td style={{textAlign: "center"}}>
                                            {
                                                findProject(item.data, proj)
                                            }
                                        </td>
                                    )
                                }
    
                                <td style={{textAlign: "center", background: "#EFEFEF"}}>
                                    {item?.sum?.toFixed(2)}
                                </td>
    
                            </tr>
                        )
                    }
    
                    <tr>
                        <td style={{background: "#D1D1D1", border: "1px solid #000"}} colSpan={2}>
                            <b>Total expense / month</b>
                        </td>
    
                        {
                            statProjectForExport.map((proj: any) =>
                                <td style={{textAlign: "center", background: "#D1D1D1", border: "1px solid #000"}}>
                                    {
                                        sumTotalForProj(proj)
                                    }
                                </td>
                            )
                        }
    
                        <td style={{textAlign: "center", color: "#ff0000", background: "#D1D1D1", border: "1px solid #000"}}>
                            <b>{allSumForTable.toFixed(2)}</b>
                        </td>
                    </tr>
                </tbody>

            </table>}

        </>
    )
}
